module.exports = __webpack_public_path__ + "static/grand_tetons1_small2-f67e45843fe5fec3d19b7d2690a7df90.jpg";